module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!completeProfileOnPageLoad || !profileCompleteness.allComplete) { ;
__p += '\n    <div class="profile-checklist ';
 if (profileCompleteness.allComplete) { ;
__p += 'profile-checklist--complete';
 } else { ;
__p += 'profile-checklist--incomplete';
 } ;
__p += '">\n        <div class="profile-checklist__content">\n            <div class="profile-checklist__summary">\n                <h3 class="profile-checklist__title">\n                    Your Profile is\n                    ';
 if (profileCompleteness.numberComplete <= 1) { ;
__p += '\n                        <span class="profile-checklist__grade profile-checklist__grade--gold">OK</span>\n                    ';
 } else if (profileCompleteness.numberComplete === 2) { ;
__p += '\n                        <span class="profile-checklist__grade profile-checklist__grade--gold">Good</span>\n                    ';
 } else { ;
__p += '\n                        <span class="profile-checklist__grade profile-checklist__grade--purple">Excellent</span>\n                    ';
 } ;
__p += '\n                </h3>\n\n                ';
 if (profileCompleteness.allComplete) { ;
__p += '\n                    <p>Nice! Your profile is among the top 20%.</p>\n\n                    <p>\n                        You can always come back and continue to refine your profile. It\'s what hiring\n                        managers see when you apply, so make it the best representation of you!\n                    </p>\n                ';
 } ;
__p += '\n                ';
 if (!profileCompleteness.allComplete) { ;
__p += '\n                    <p class="profile-checklist__best-results">\n                        Avoid pitfalls that many applications are screened out for. Be sure to:\n                    </p>\n                ';
 } ;
__p += '\n            </div>\n\n            <div class="profile-checklist__checklist">\n                ';
 if (profileCompleteness.allComplete) { ;
__p += '\n                    <p><a href="/" class="profile-checklist__go-to-home">Go to Home</a></p>\n                ';
 } else { ;
__p += '\n                    <ul>\n                        <li>\n                            ';
 if (profileCompleteness.tasks.addJobs) { ;
__p += '\n                                ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n                            ';
 } else { ;
__p += '\n                                ' +
((__t = ( $.svgIcon('pass') )) == null ? '' : __t) +
'\n                            ';
 } ;
__p += '\n                            <div>Add <em>all</em> jobs from the last 5 years</div>\n                            ';
 if (!profileCompleteness.tasks.addJobs) { ;
__p += '\n                                <a class="profile-checklist__im-done" href="javascript:void(0);">\n                                    Click here if you have no more jobs to add\n                                </a>\n                            ';
 } ;
__p += '\n                        </li>\n                        <li>\n                            ';
 if (profileCompleteness.tasks.jobDescriptions) { ;
__p += '\n                                ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n                            ';
 } else { ;
__p += '\n                                ' +
((__t = ( $.svgIcon('pass') )) == null ? '' : __t) +
'\n                            ';
 } ;
__p += '\n                            Provide job descriptions that are at least a few sentences long\n                        </li>\n                        <li>\n                            ';
 if (profileCompleteness.tasks.personalSummary) { ;
__p += '\n                                ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n                            ';
 } else { ;
__p += '\n                                ' +
((__t = ( $.svgIcon('pass') )) == null ? '' : __t) +
'\n                            ';
 } ;
__p += '\n                            Include a personal summary\n                        </li>\n                    </ul>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </div>\n';
 } ;
__p += '\n\n<div class="profile-content">\n    ';
 if (user.prefs.search_status) { ;
__p += '\n    <div class="profile-status hidden-mobile">\n        Status:\n        <strong class="js-candidate-status-text">' +
__e( user.prefs.statusText ) +
'</strong>\n\n        <a href="javascript://" class="secondary-text-link js-edit-preferences">Edit</a>\n    </div>\n    ';
 } ;
__p += '\n\n    <div class="profile-header">\n        <div class="profile-header-container">\n            <div class="edit-button">\n                <a href="#" data-step="STEP_INFO">\n                    ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n            <div class="profile-header-icon">\n                <div class="profile-header-initials">\n                    <span class="js-user-initials">' +
__e( user.initials ) +
'</span>\n                </div>\n\n                ';
 if (user.prefs.search_status) { ;
__p += '\n                <div class="mobile-only profile-status-mobile candidate-status' +
__e( user.prefs.search_status ) +
'">\n                    <div class="profile-status-mobile-container" style="display: none;">\n                        <p>Your job search status:</p>\n                        <strong class="js-candidate-status-text">' +
__e( user.prefs.statusText ) +
'</strong>\n\n                        <a href="javascript://" class="js-edit-preferences">Edit Status</a>\n                    </div>\n                </div>\n                ';
 } ;
__p += '\n            </div>\n            <div class="profile-header-content">\n                <div>\n                    <h1 class="js-user-fullname fs-hide">' +
__e( user.full_name ) +
'</h1>\n                    <a href="#" class="nav-link js-print-resume hidden-mobile btn btn-secondary btn-small" onclick="window.print();">Print</a>\n                </div>\n                <span class="profile-header-location fs-hide">' +
__e( user.city ) +
'</span>\n            </div>\n        </div>\n        <div class="profile-stats-summary">\n            <div class="profile-stats-summary__stat">\n                <span>\n                    ' +
__e( profileCompleteness.experienceYears ) +
'\n                </span>\n                <span>Total Exp</span>\n            </div>\n            <div class="profile-stats-summary__stat">\n                <span>\n                    ' +
__e( profileCompleteness.jobCount ) +
'\n                </span>\n                <span>Jobs Listed</span>\n            </div>\n            <div class="profile-stats-summary__stat">\n                <span>\n                    ' +
__e( profileCompleteness.detailLevel ) +
'\n                </span>\n                <span>Detail</span>\n            </div>\n        </div>\n        <div class="profile-summary';
 if (!self_promo) { ;
__p += ' profile__section--empty';
 } ;
__p += '">\n            <div class="edit-button">\n                <a href="#" data-step="STEP_SUMMARY">\n                    ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n            ';
 if (self_promo) { ;
__p += '\n                <p>' +
__e( self_promo ) +
'</p>\n            ';
 } else { ;
__p += '\n                <span><i>e.g. "Hard worker, always on time, have 5 years experience..."</i></span>\n                <a href="#" class="no-summary" data-step="STEP_SUMMARY">+Add summary</a>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n\n    <div class="candidate-profile">\n        <section class="work-experience">\n            <header>\n                <h2>Work History</h2>\n                ';
 if (jobs.length > 0) { ;
__p += '\n                <div class="edit-button">\n                    <a href="#" data-step="STEP_HISTORY">\n                        ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                        <span class="hidden-mobile">Edit</span>\n                    </a>\n                </div>\n                ';
 } ;
__p += '\n            </header>\n\n            <div>\n                ';
 if (jobs.length === 0) { ;
__p += '\n                    <div class="profile__section--empty">\n                        <span><i>No work history listed yet</i></span>\n                        <a href="#" data-step="STEP_HISTORY">+Add Work History</a>\n                    </div>\n                ';
 } else { ;
__p += '\n                    ';
 jobs.forEach(function(job) { ;
__p += '\n                        ';
 if (!job.title) { ;
__p += '\n                            ';
 if (job.reason) { ;
__p += '\n                            <article class="gap-explanation">\n                                <div class="job-icon">\n                                    <div class="job-line"></div>\n                                    <div class="gap-icon">\n                                        <div></div>\n                                    </div>\n                                </div>\n                                <div class="job-content">\n                                    <span class="dates">' +
__e( job.start_date ) +
' &ndash; ' +
__e( job.end_date ) +
' &bull; ' +
__e( job.durationString ) +
'</span>\n                                    <p class="fs-hide">\n                                        ' +
__e( job.reason ) +
'\n                                    </p>\n                                </div>\n                            </article>\n                            ';
 } ;
__p += '\n                        ';
 } else { ;
__p += '\n                            <article class="job-description">\n                                <div class="job-icon">\n                                    <div class="job-line"></div>\n                                    <div class="job-icon-container">\n                                        ' +
((__t = ( $.svgIcon('briefcase') )) == null ? '' : __t) +
'\n                                    </div>\n                                </div>\n                                <div class="job-content">\n                                    <header>\n                                        <div class="job-title">\n                                          <strong class="item-title job-title__role">' +
__e( job.title ) +
'</strong>\n                                          ';
 if (job.displayAsContractJob) {;
__p += '<span class="job-title__contract">Contract</span>';
 } ;
__p += '\n                                        </div>\n                                        <span class="company fs-hide">' +
__e( job.company ) +
'</span>\n                                        <span class="dates">' +
__e( job.start_date ) +
' &ndash; ' +
__e( job.end_date ) +
' &bull; ' +
__e( job.durationString ) +
'</span>\n                                    </header>\n                                    <p class="duties">' +
__e( job.duties ) +
'</p>\n                                    ';
 if (job.reason_for_leaving) { ;
__p += '\n                                    <div class="reason-for-leaving fs-hide">\n                                        Reason for leaving: ' +
__e( job.reason_for_leaving ) +
'\n                                        ';
 if (job.reason_explain) { ;
__p += '\n                                            (' +
__e( job.reason_explain ) +
')\n                                        ';
 } ;
__p += '\n                                    </div>\n                                    ';
 } ;
__p += '\n                                    <span class="location fs-hide">' +
__e( job.city ) +
', ' +
__e( job.state ) +
'</span>\n                                </div>\n                            </article>\n                        ';
 } ;
__p += '\n                    ';
 }); ;
__p += '\n                    <div class="work-experience__add-job">\n                        <span><i>Do you have any other jobs to add?</i></span>\n                        <a href="#" data-step="STEP_HISTORY">+Add Job</a>\n                    </div>\n                ';
 } ;
__p += '\n            </div>\n        </section>\n\n        ';
 if (showEducationSection) { ;
__p += '\n            <section class="review-list">\n                <header>\n                    <h2>Education</h2>\n                    ';
 if (schools.length > 0) { ;
__p += '\n                        <div class="edit-button">\n                            <a href="#" data-step="STEP_INFO">\n                                ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                                <span class="hidden-mobile">Edit</span>\n                            </a>\n                        </div>\n                    ';
 } ;
__p += '\n                </header>\n\n                ';
 if (schools.length === 0) { ;
__p += '\n                    <div class="profile__section--empty">\n                        <span><i>No education listed yet</i></span>\n                        <a href="#" data-step="STEP_INFO">+Add Education</a>\n                    </div>\n                ';
 } else { ;
__p += '\n                    <div>\n                        ';
 schools.forEach(function(school) { ;
__p += '\n                        <article class="icon-article">\n                            <div class="icon-container">\n                                ' +
((__t = ( $.svgIcon('education') )) == null ? '' : __t) +
'\n                            </div>\n                            <div>\n                                ';
 if (school.name) { ;
__p += '\n                                  <strong class="school-name fs-hide">' +
__e( school.name ) +
'</strong>\n                                ';
 } ;
__p += '\n                                <span class="degree-type">' +
__e( school.degree_type_string ) +
'</span>\n                                ';
 if (school.degree_major) { ;
__p += '\n                                  <span>' +
__e( school.degree_major ) +
'</span>\n                                ';
 } ;
__p += '\n                            </div>\n                        </article>\n                        ';
 }) ;
__p += '\n                    </div>\n                ';
 } ;
__p += '\n            </section>\n        ';
 } ;
__p += '\n\n        ';
 if (skills.length > 0) { ;
__p += '\n        <section class="r-company-questions">\n            <header>\n                <h2>Skills and Experience</h2>\n                <div class="edit-button">\n                    <a href="#" data-step="STEP_SKILLS">\n                        ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                        <span class="hidden-mobile">Edit</span>\n                    </a>\n                </div>\n            </header>\n\n            <article class="review-question">\n                <ul class="questions">\n                ';
 skills.forEach(function(question) { ;
__p += '\n                    <li class="';
 if (question.followup) { ;
__p += 'followup';
 } ;
__p += '">\n                        <span class="question">' +
__e( question.question ) +
'</span>\n                        <strong class="answer">' +
__e( question.value ) +
'</strong>\n                    </li>\n                ';
 }) ;
__p += '\n                </ul>\n            </article>\n        </section>\n        ';
 } ;
__p += '\n\n        <section class="hide-for-print">\n            <header>\n                <h2>Shift Preferences</h2>\n                ';
 if (pref_shift_day) { ;
__p += '\n                    <div class="edit-button">\n                        <a href="#" data-step="STEP_AVAILABILITY">\n                            ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                            <span class="hidden-mobile">Edit</span>\n                        </a>\n                    </div>\n                ';
 } ;
__p += '\n            </header>\n            <article>\n                ';
 if (!pref_shift_day) { ;
__p += '\n                    <div class="profile__section--empty">\n                        <span><i>Not set yet</i></span>\n                        <a href="#" data-step="STEP_AVAILABILITY">Set Shift Preferences</a>\n                    </div>\n                ';
 } else { ;
__p += '\n                    <div id="availability" class="availability-container"></div>\n                ';
 } ;
__p += '\n            </article>\n        </section>\n\n        <section class="r-references review-list">\n            <header>\n                <h2>Professional References</h2>\n                ';
 if (references.length > 0 ) { ;
__p += '\n                    <div class="edit-button">\n                        <a href="#" class="js-add-reference">\n                            ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                            <span class="hidden-mobile">Add</span>\n                        </a>\n                    </div>\n                ';
 } ;
__p += '\n            </header>\n\n            ';
 if (references.length === 0) { ;
__p += '\n                <div class="profile__section--empty">\n                    <span><i>Ask a former manager or supervisor to write a recommendation</i></span>\n                    <a href="#" class="js-add-reference">+Request a recommendation</a>\n                </div>\n            ';
 } else { ;
__p += '\n                <div>\n                    ';
 references.forEach(function(job) { ;
__p += '\n                        <article class="icon-article fs-hide">\n                            <div class="reference-meta-row">\n                                <div class="icon-container">\n                                    ' +
((__t = ( $.svgIcon('profile') )) == null ? '' : __t) +
'\n                                </div>\n                                <div class="reference-meta">\n                                    <div class="manager-info">\n                                        <span class="manager-name">' +
__e( job.manager_name ) +
'</span>\n                                        <span class="manager-title">\n                                            ' +
__e( job.reference_relationship ) +
'\n                                        </span>\n                                    </div>\n                                    <span class="manager-phone">\n                                        ' +
((__t = ( $.svgIcon('phone') )) == null ? '' : __t) +
'\n                                        <span>' +
__e( job.manager_number ) +
'</span>\n                                    </span>\n                                </div>\n                            </div>\n                            ';
 if (job.reference_confirmed) { ;
__p += '\n                                <div class="reference-message">\n                                    ';
 if (job.reference_other) { ;
__p += '\n                                        "' +
__e( job.reference_other ) +
'"\n                                    ';
 } ;
__p += '\n                                    <div class="confirmed-reference">\n                                        ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'Confirmed ' +
__e( user.first_name ) +
'\'s employment\n                                    </div>\n                                </div>\n                            ';
 } ;
__p += '\n                        </article>\n                    ';
 }) ;
__p += '\n                </div>\n            ';
 } ;
__p += '\n        </section>\n    </div>\n</div>\n';

}
return __p
}